<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" @click.stop>
                <div class="dialog-title">
                    <div v-if="authUsers.length === 0" v-t="'message.title_add_stt_dictionary_auth_user'"></div>
                    <div v-else v-t="'message.title_edit_stt_dictionary_auth_user'"></div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body">
                    <UserSelection :appData="appData" :title="selectedTitle" :selectedUsers="authUsers"
                        :selectionType="selectionType" :showAdminUser="true" @changeSelectedUser="handleChangeSelectedUser"
                        ref="UserSelection">
                    </UserSelection>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')"
                        v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="disableSave" @click="saveUpdatedInfo"
                        v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import UserSelection from '@/components/UserSelection.vue';
import commonUtil from '@/components/commonutil.js';
import constants from '@/components/constants.js';

export default {
    components: {
        UserSelection,
    },

    props: {
        appData: Object,
        authUsers: Array,
    },

    data() {
        return {
            disableSave: true,
            selectedTitle: commonUtil.getMessageText(this.$i18n, "action_edit_stt_dictionary_auth_user"),
            selectionType: constants.USER_SELECTION_DICTIONARY_AUTH,
        };
    },

    methods: {
        handleChangeSelectedUser() {
            this.disableSave = false;
        },
        saveUpdatedInfo() {
            this.$emit('save', { removeTagList: this.$refs.UserSelection.removeTagList, addTagList: this.$refs.UserSelection.addTagList });
        },
    }
}
</script>


<style scoped>
.input-with-select>>>.el-input-group__prepend {
    background-color: #fff;
}

.input-with-select>>>.el-select .el-input {
    font-size: 14px;
    width: 120px;
}

.input-with-select>>>.el-button {
    width: 40px;
    padding: 0;
}
</style>
